import { Callout, IconClear, TextDecorated, t } from '@airvantage/ui';
import { Flex } from 'reflexion';
import SemtechLogoImg from '../img/semtechLogo.svg';

export default function Error() {
  const windowParams = window?.params;
  const errorCode = windowParams?.error;
  const errorMessage = windowParams?.errorMessage;
  const description =
    errorCode && errorMessage
      ? `${errorCode} : ${errorMessage}`
      : (errorCode ?? errorMessage ?? t('Resource not found.'));

  return (
    <Flex className="min-h-screen" direction="horizontal" width="fill" align="center">
      <Flex className="min-w-[400px] p-5" direction="vertical" gap={16} height="fill" width="30%">
        <Flex align="center" className="h-24 w-full" direction="horizontal">
          <img src={SemtechLogoImg} alt="Semtech Logo" className="h-24 w-full" />
        </Flex>
        <Flex align="center" class="overflow-auto p-1" direction="vertical" gap={16} height="fill" width="fill">
          <Callout description={description} error icon={<IconClear />} title={t('Something went wrong!')} />
        </Flex>
        <Flex className="flex w-full justify-center gap-2">
          <label className="text-center">
            {t('If you have any questions or concerns, please contact our support team.')}
          </label>
        </Flex>
        <Flex align="center" direction="horizontal" gap={8} width="fill"></Flex>
        <Flex className="flex justify-center p-1" width="fill">
          <TextDecorated class="text-xs" value={t('©Semtech, 2025. All Rights Reserved')} />
        </Flex>
      </Flex>
    </Flex>
  );
}
